import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ReportParameterListComponent from './ReportParameterListComponent';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import Font from '@mui/icons-material/FormatListNumberedRtlSharp';

const ReportParameterListCard = ({
  reportParameters,
  reportContextParameters,
  reportParameterTypes,
  onAdd,
  onPropertyChanged,
  onExpandedChanged,
  onSave,
  onDelete,
  validation
}) => {
  const [t] = useTranslation();

  return (
    <Card
      icon={Font}
      iconColor='primary'
      title={t('Reports.ReportParameters.Title')}
      actions={<IconButton color='transparent' type='add' fontSize='medium' tooltip={t('Tooltips.Add')} onClick={onAdd} />}
    >
      <ReportParameterListComponent
        reportParameters={reportParameters}
        reportParameterTypes={reportParameterTypes}
        reportContextParameters={reportContextParameters}
        onExpandedChanged={onExpandedChanged}
        onPropertyChanged={onPropertyChanged}
        onSave={onSave}
        onDelete={onDelete}
        validation={validation}
      />
    </Card>
  );
};

ReportParameterListCard.propTypes = {
  reportParameters: PropTypes.array.isRequired,
  reportParameterTypes: PropTypes.array,
  reportContextParameters: PropTypes.array,
  onAdd: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onExpandedChanged: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  validation: PropTypes.object
};

export default ReportParameterListCard;
